import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../shared/shared.module";
import { IconsModule } from "../icons/icons.module";
import { Step1Component } from "./step1/step1.component";
import { Step2Component } from "./step2/step2.component";
import { Step3Component } from "./step3/step3.component";
import { Step4Component } from "./step4/step4.component";
import { Step5Component } from "./step5/step5.component";

@NgModule({
    imports: [CommonModule, SharedModule, IconsModule],
    declarations: [
        Step1Component,
        Step2Component,
        Step3Component,
        Step4Component,
        Step5Component,
    ],
    exports: [
        Step1Component,
        Step2Component,
        Step3Component,
        Step4Component,
        Step5Component,
    ],
})
export class PagesModule {}
